<script lang="ts">
    import { openModal } from 'svelte-modals';

    import MessageDangerInline from './MessageDangerInline.svelte';
    import ModalError from '../Modals/ModalError.svelte';

    export let header: string = 'An error occurred';
    export let message: string = 'errors_while_loading';
    export let error: string = '';
    export let footer: boolean = true;
    export let hideButton: boolean = true;

    let visible: boolean = true;

    $: {
        if (visible) {
            openModal(ModalError, { message, error, header });
        }
    }
</script>

{#if visible && false}
    <MessageDangerInline {header} {message} {error} {footer} {hideButton} />
{/if}
